  export interface SFTPState {
    dealerInfo: any,
    isSftpUserNotReportingAlertsEnabled: boolean,
    emails: Array<any>,
    rules: Array<any>
    allDealerCodes: any
  }
  export enum SFTPActionNames {
    SET_DEALER_INFO = 'SET_DEALER_INFO',
    GET_DEALER_INFO = 'GET_DEALER_INFO',
    SET_ALL_DEALERS = 'SET_ALL_DEALERS',
  }

  interface SetDealerInfo {
    type: typeof SFTPActionNames.SET_DEALER_INFO;
    payload: any;
  }
  interface GetDealerInfo {
    type: typeof SFTPActionNames.GET_DEALER_INFO;
    payload: any;
  }
  interface SetAllDealers {
    type: typeof SFTPActionNames.SET_ALL_DEALERS;
    payload: any;
  }

  export type SFTPActionTypes =
    | GetDealerInfo
    | SetDealerInfo
    | SetAllDealers
